<header class="header-v2 {{isLocalhost ? 'add-padding' : ''}}" role="banner">
  <!-- AI BANNER ROW: Blue banner at the top -->
  <div *ngIf="showAIBanner" class="ai-banner-row" [class.banner-visible]="isBannerVisible" [class.banner-hidden]="!isBannerVisible" role="region" aria-label="AI Integration banner">
    <div class="ai-banner-container">
      <div class="ai-banner-content">
        <!-- <span class="ai-banner-icon">✨</span> -->
        <span class="ai-banner-text">Want verified cable sizing inside ChatGPT & Claude?</span>
        <!-- <span class="ai-banner-text mobile-only">Connect free to ChatGPT or Claude?</span> -->
      </div>
      <div class="ai-banner-actions">
        <a href="https://elek.com/tutorials/cable-pro-web/getting-started-ai-mcp/" target="_blank" class="btn btn-amber ai-banner-btn" aria-label="Connect for free">
          Get it now
        </a>
        <!-- <button type="button" class="ai-banner-close" 
          title="Close"
        (click)="showAIBanner = false" aria-label="Close banner">
          ✕
        </button> -->
      </div>
    </div>
  </div>

  <!-- ROW 1: Primary Header (Desktop & Mobile) -->
  <nav class="header-row-1" role="navigation" aria-label="Main header">
    <div class="header-brand-detail">

      <!-- Logo (Left) -->
      <div class="header-logo">
        <a href="{{ redirectUrl }}" class="logo-link" aria-label="Elek home" tabindex="1">
          <img class="logo-img" src="assets/cablepro/logo/elek-logo.svg" alt="Elek" height="40">
        </a>
      </div>

      <!-- Page Title (Center) -->
      <div class="header-title">
        <h1 class="page-title">
          <span class="full-title"> {{ getFullCalculatorTitle() }} </span>
          <span class="sort-title"> {{ getFullCalculatorTitle(true) }} </span>
          
        </h1>
      </div>


      <!-- Hamburger Menu Button (Mobile) -->
      <button type="button" class="header-hamburger" (click)="toggleMobileMenu()" [class.open]="isMobileMenuOpen"
        aria-label="Toggle navigation menu" [attr.aria-expanded]="isMobileMenuOpen" tabindex="1">
        <span class="hamburger-bar"></span>
        <span class="hamburger-bar"></span>
        <span class="hamburger-bar"></span>
      </button>

    </div>


    <!-- Actions (Right) - Desktop View -->
    <div class="header-actions {{isMobileMenuOpen ? 'mobile-menu-open' : ''}}">
      <!-- Generate Report Button -->
      <button *ngIf="showGenerateReport && !(_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1  || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)" type="button" class="btn btn-amber"
        (click)="onReportClick()" [disabled]="isReportDisabled || isGeneratingReport" tabindex="1" aria-label="Generate Report">
        <img *ngIf="!isGeneratingReport" src="assets/custom/img/generate-report.svg" alt="Generate Report" class="report-icon-svg" />
        <span>{{ isGeneratingReport ? 'Generating...' : 'Generate Report' }}</span>
        <i *ngIf="isGeneratingReport" class="fa fa-spinner fa-spin ml-1" aria-hidden="true"></i>
      </button>

      <div class="btn-group ml-0 theme-custom" *ngIf="showGenerateReport && (_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1  || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)">
        <a href="javascript:;" class="dropdown-toggle btn btn-amber" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false" [class.disabled]="isReportDisabled || isGeneratingReport" [attr.aria-disabled]="isReportDisabled || isGeneratingReport" tabindex="1" aria-label="Generate Report options">
          <img *ngIf="!isGeneratingReport" src="assets/custom/img/generate-report.svg" alt="Generate Report" class="report-icon-svg" /> 
          <span>{{ isGeneratingReport ? 'Generating...' : 'Generate Report' }}</span>
          <i *ngIf="isGeneratingReport" class="fa fa-spinner fa-spin ml-1" aria-hidden="true"></i>
        </a>
        <div class="dropdown-menu" style="width: 99% !important;">
          <a class="dropdown-item" href="javascript:void(0);" (click)="onReportClick()" tabindex="1"
            aria-label="Cable Sizing">Cable Sizing</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="onCalculationStep()" tabindex="1"
            aria-label="Calculation Steps">Calculation Steps <img
              [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FDCSCSIS) ? 'crown-grey' : 'crown-yellow'"
              class="" src="assets/cablepro/img/crown-solid.svg" height="12.27" width="12.27" alt="Premium"
              style="vertical-align: baseline;"></a>
        </div>
      </div>

      <div *ngIf="showGenerateReport" class="row1-divider"></div>

      <!-- Login Button -->
      <button *ngIf="!user || user.isWebFacingUser" type="button" class="btn btn-outlined" (click)="onLogin()"
        aria-label="Log In" tabindex="1">
        Log In
      </button>

      <!-- <div *ngIf="user && user.id > 0 && !user.isWebFacingUser" class="user-info" title="{{ user.userName }}"
        aria-label="Logged in as {{ user.userName }}">
        {{ user.userName }}
    </div> -->

    <div class="user-info"
        *ngIf="user && user.id > 0 && !user.isWebFacingUser" title="{{ user.emailAddress }}">
        <span class="text-truncate">
          {{ user.emailAddress }}
        </span>
        <span class="badge" *ngIf="user.userStripePlanLevel>=0" [ngClass]="{
          'badge-info': user.userStripePlanLevel == 1,
          'badge-primary': user.userStripePlanLevel == 2,
          'badge-success': user.userStripePlanLevel == 3
        }">
          {{ getLatestPlanName(user.userStripePlanLevel) }}
        </span>
      </div>

      <!-- Logout Button -->
      <button *ngIf="user && user.id > 0 && !user.isWebFacingUser" type="button" class="btn btn-outlined"
        (click)="logout()" aria-label="Log Out" tabindex="1">
        Log Out
      </button>

      <!-- Pricing Button -->
      <button
        *ngIf="user && user.id > 0 && !user.isWebFacingUser && !(_router.url.indexOf('/pricing') > -1)"
        type="button" class="btn btn-filled" (click)="UpgradePlan()" aria-label="View Pricing" tabindex="1">
        Pricing
      </button>

      <!-- Create Free Account Button -->
      <button *ngIf="!user || user.isWebFacingUser" type="button" class="btn btn-filled" (click)="onRegister()"
        tabindex="1" aria-label="Create Free Account">
        Create Free Account
      </button>
    </div>
  </nav>

  <!-- ROW 2: Calculator Tabs Navigation (Desktop) -->
  <nav *ngIf="showGenerateReport" class="navbar navbar-expand-lg header-row-2 mx-2" role="navigation"
    aria-label="Calculator navigation">
    <div class="container-fluid px-0">
      <!-- Navbar toggler for mobile - Shows active tab -->
      <button class="navbar-toggler dropdown-toggle right-side-icon" type="button" *ngIf="getActiveTab() as activeTab" (click)="toggleTabsMenu()"
        [attr.aria-expanded]="isTabsMenuOpen" aria-label="Toggle tabs menu" aria-controls="tabsNavbar" tabindex="1">
        <img *ngIf="activeTab.svgPath" [src]="activeTab.svgPath" [alt]="activeTab.label + ' icon'"
          class="tab-icon-svg" />
        <i *ngIf="!activeTab.svgPath" [class]="activeTab.icon"></i>
        <span class="tab-label" [attr.data-text]="activeTab.label">{{ activeTab.label }}</span>
      </button>

      <!-- Collapsible navbar content -->
      <div class="collapse navbar-collapse" id="tabsNavbar" [class.show]="isTabsMenuOpen">
        <ul class="navbar-nav tabs-container">
          <!-- Calculator Tabs -->
          <li *ngFor="let tab of calculatorTabs" class="nav-link tab {{tab.id}}" [class.active]="tab.isActive"
            [attr.aria-label]="tab.label + ' calculator'" [attr.aria-current]="tab.isActive ? 'page' : false">
            <a href="javascript:void(0);" class="item {{tab.id === 'cable-sizing' ? 'cable-sizing' : ''}}"
              (click)="tab.id === 'cable-sizing' ? toggleStandardsDropdown() : onTabChange(tab)" tabindex="1">
              <img *ngIf="tab.svgPath" [src]="tab.svgPath" [alt]="tab.label + ' icon'" class="tab-icon-svg mr-1" />
              <i *ngIf="!tab.svgPath" [class]="tab.icon"></i>
              <span class="tab-label" [attr.data-text]="tab.label">{{ tab.label }}</span>
              <div *ngIf="tab.id === 'cable-sizing'" class="standard-dropdown-inline">
                <span class="standard-label">{{ standardVariant }}</span>
                <span [attr.aria-expanded]="isStandardsDropdownOpen" aria-label="Select standard variant"
                  class="dropdown-toggle"></span>
              </div>
            </a>
            <!-- Dropdown Menu -->
            <div *ngIf="tab.id === 'cable-sizing' && isStandardsDropdownOpen" class="standard-dropdown-menu">
              <a *ngFor="let variant of standardVariants" href="javascript:void(0);" class="dropdown-item"
                  tabindex="1" [class.active]="variant.label === standardVariant" 
                  (click)="onStandardChange(variant)">
                {{ variant.label }}
              </a>
            </div>
          </li>


          <li *ngIf="user && user.id > 0 && !user.isWebFacingUser" 
            class="btn-saved-calculation"
            [attr.aria-label]="'Saved Calculations'" >
            <button href="javascript:void(0);" class="btn btn-outline btn-sm" (click)="onAllProjectsClick()"
               tabindex="1">
              <!-- <img *ngIf="tab.svgPath" [src]="tab.svgPath" [alt]="tab.label + ' icon'" class="tab-icon-svg mr-1" /> -->
              <!-- <i *ngIf="!tab.svgPath" [class]="tab.icon"></i> -->
              <i class="fa fa-floppy-o tab-icon mr-1" aria-hidden="true"></i>
              <span class="tab-label">Saved Calculations</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<div class="powered-by-sticky" *ngIf="showReportButton">
  <span class="powered-by-text">Powered by</span>
  <a (click)="redirectToFullAppUrl()" class="powered-by-btn">Cable Pro Web<sup>TM</sup></a>
</div>